import { useQuery } from "react-query";
import { getHierarchyActivityHistoryById } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetHierarchyActivityHistoryById = (hierarchyId) => {
  return useQuery(
    ["GetHierarchyActivityHistoryById", hierarchyId],
    () => getHierarchyActivityHistoryById(hierarchyId),
    {
      refetchOnWindowFocus: false,
    }
  );
};
